import { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import axios from '../../../axiosInstance.js';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import telephonecall from '../../../Assets/telephonecall.png'
import { MapContainer, TileLayer } from 'react-leaflet';
import ModalButton from "../../Customers/FirstPageDesigns/ModalButton";
import { Info, MapPin, PhoneCall, X } from "lucide-react";
import mediumCrane from '../../../Assets/crane/mediumCrane.jpg'
import mediumRecoveryVan from '../../../Assets/crane/mediumRecoveryVan.jpg'
import frontLeft from '../../../Assets/crane/front-left.jpg'
import OLAMapsForDriverLocation from "../../../Component/Customers/OLAMapsForDriverLocation";
import { useWebSocket } from "../../../context/WebSocketContext.jsx";
import OLAMapsForCustomerView from "../../../Component/Customers/OLAMapsForCustomerView.jsx";
import ShowVehicleInspectionFlow from "../../Customers/FirstPageDesigns/VehicleInspectionFlow.jsx";


const VendorMoving = ({ item, fromPage }) => {
    const navigate = useNavigate()
    console.log("itemfromvendormoving", item)
    console.log("itemfromvendormoving", item.details[0].cancelOrder)
    const { messages, setMessages } = useWebSocket();
    const [isModalOpenForOTP, setIsModalOpenForOTP] = useState(false);

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState(null);
    const [distance, setDistance] = useState('');
    const [driverLocation, setDriverLocation] = useState(null);
    console.log('driverLocation current 123', driverLocation)

    const [selectedId, setSelectedId] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showAddedDataByVendor, setShowAddedDataByVendor] = useState(false);
    const [showFull, setShowFull] = useState(false);
    const [showFull2, setShowFull2] = useState(false);

    const [otp, setOtp] = useState("");
    const inputRef = useRef(null);

    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, "").slice(0, 6); // Only digits, max 6
        setOtp(value);
    };

    console.log("distacne", distance)

    function haversine(lat1, lon1, lat2, lon2) {
        const toRad = (value) => (value * Math.PI) / 180;
        const R = 6371; // Earth radius in km

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance;
    }

    useEffect(() => {
        if (messages.length > 0) {
            console.log('messages123 vendor tracking');

            const remainingMessages = [];

            messages.forEach((message) => {
                if (message.forPage === "updated-location") {
                    console.log("***********************WebSocket messages received: vendor moving", messages);
                    console.log('📍 Driver location update', message);
                    if (item.AccidentVehicleCode === message.accidentVehicleCode) {
                        setDriverLocation({ lat: message.lat, lng: message.lng });
                    }
                } else {
                    // Keep any unrecognized message for future processing
                    remainingMessages.push(message);
                }
            });

            // ✅ Clear used messages
            if (remainingMessages.length !== messages.length) {
                // You’ll need this from useWebSocket or Redux or Context
                if (typeof setMessages === 'function') {
                    setMessages(remainingMessages);
                } else {
                    console.warn("setMessages not available. Skipping message cleanup.");
                }
            }

            console.log('🔚 Done processing websocket messages');
        }
    }, [messages]);

    console.log("item in vendorMoving", item)
    const [imageContainer, setImageContainer] = useState(false)
    const [showDetails, setShowDetails] = useState(false)


    useEffect(() => {
        if (item.reg != undefined) {
            setImageContainer(true)
        }
        console.log("item item.details[0]?.driverLatitude", item.details[0]?.driverLatitude)
        setDriverLocation({ lat: item.details[0]?.driverLatitude, lng: item.details[0]?.driverLongitude });
        setShowDetails(true);
        if (item.details[0]?.approvedRightlyMeasured && item.details[0]?.otp && item.details[0]?.otpByCustomer == null) {
            setIsModalOpenForOTP(true);
        }
    }, [item])

    const getCurrentLocation = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorCurrentLocation/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data.status === true) {
                let vendorCurrentLatitude = response.data.data[0].latitude;
                let vendorCurrentLongitude = response.data.data[0].longitude;
                setVendorCurrentLatitude(vendorCurrentLatitude)
                setVendorCurrentLongitude(vendorCurrentLongitude)
                console.log("userId", userId)
                console.log('baho', item.accidentLatitude, item.accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude)

                setDistance(haversine(item.accidentLatitude, item.accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude).toFixed(2))
            }
            else if (response.data.message === "User Not found take Location") {
                console.log("User Not found take Location")
            }
        } catch (error) {
            console.log("error in get Vendor Location", error.message)
        }
    }

    const readyToGo = async () => {
        try {
            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/vendorMoved/${userId}/${item.AccidentVehicleCode}/${item.details[0].vendorType}`, {
                method: 'PUT',
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status) {
                console.log('successfully updated status')
            }
            else console.log("there is some issue")

        }
        catch (error) {
            console.log("the error occured", error.message)
        }
    }

    const reachedLocation = async () => {
        try {
            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/vendorReachedLocation/${userId}/${item.AccidentVehicleCode}/${userId}/${item.details[0].vendorType}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.status) {
                setAlertMessage("Updated successfully!");
                setAlertType("success"); // Bootstrap alert type for success
            } else {
                setAlertMessage("There is some issue.");
                setAlertType("danger"); // Bootstrap alert type for error
            }
        } catch (error) {
            setAlertMessage(`An error occurred: ${error.message}`);
            setAlertType("danger"); // Bootstrap alert type for error
        }

        setTimeout(() => {
            setAlertMessage(null);
        }, 5000);
    };

    const sendOTP = async (item) => {
        try {
            let response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/vendorOTPValidation/${userId}/${item.AccidentVehicleCode}/${userId}/${item.details[0].vendorType}`,
                { otp: otp }, // ✅ correct way to send data
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );


            console.log("response.data.status12345", response.data)
            if (response.data.status) {
                setAlertMessage("Updated successfully!");
                setAlertType("success"); // Bootstrap alert type for success
            } else if (response.data.status == false) {
                setAlertMessage("Wrong OTP");
                setAlertType("danger"); // Bootstrap alert type for success
            }
            else {
                setAlertMessage("There is some issue.");
                setAlertType("danger"); // Bootstrap alert type for error
            }
        } catch (error) {
            setAlertMessage("Wrong OTP");
            setAlertType("danger"); // Bootstrap alert type for success
        }
        finally {
        }


    };

    const workDone = async () => {
        try {
            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/VendorWorkDone/${userId}/${item.AccidentVehicleCode}/${item.details[0].vendorType}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status) {
                setAlertMessage("Updated successfully!");
                setAlertType("success"); // Bootstrap alert type for success
            }
            else {
                setAlertMessage("There is some issue.");
                setAlertType("danger"); // Bootstrap alert type for error
            }
        }
        catch (error) {
            setAlertMessage(`An error occurred: ${error.message}`);
            setAlertType("danger"); // Bootstrap alert type for error
        }
    }

    const goToMap = () => {
        navigate('/map-vendor-distance', {
            state: {
                accidentLatitude: item.accidentLatitude,
                accidentLongitude: item.accidentLongitude,
                vendorLatitude: vendorCurrentLatitude,
                vendorLongitude: vendorCurrentLongitude,
                vehicleNo: item.reg,
                fromPage: "vendorMoving"
            }
        })
    }

    const viewData = (id, item) => {
        setSelectedId(id);
        setSelectedItem(item)
        setShowAddedDataByVendor(true)
    }

    const navigation = (selectedId, selectedItem) => {
        navigate('/crane-vehicle-information', { state: { id: selectedId, item: selectedItem } });
    };

    useEffect(() => {
        if (showAddedDataByVendor && selectedId != null) {
            navigation(selectedId, selectedItem); // Now navigation is defined above this
        }
    }, [showAddedDataByVendor, selectedId, selectedItem]); // Ensure navigation is called only when these values change



    useEffect(() => {
        if (isModalOpenForOTP) {
            setTimeout(() => inputRef.current?.focus(), 100);
        }
    }, [isModalOpenForOTP]);


    return (
        <div>
            {(

                <div className={`font-satoshi ${fromPage !== "rejected" ? 'text-overlay' : ''}`} style={{ height: "80vh", padding: '0px' }}>
                    {fromPage !== "rejected" && showDetails == true && (

                        <div className='h-full w-full '>
                            {/* <MapContainer zoom={13} center={[19.0760, 72.8777]} style={{ width: '100%', height: '100vh', borderRadius: '20px', boxShadow: '0px -13px 20px 0px' }}>
                            <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            />
                        </MapContainer> */}

                            <OLAMapsForDriverLocation
                                dropLatitude={item.details[0]?.dropLatitude}
                                dropLongitude={item.details[0]?.dropLongitude}
                                pickupLatitude={item.details[0]?.pickupLatitude}
                                pickupLongitude={item.details[0]?.pickupLongitude}
                                allowDriverProceed={item.details[0]?.allowDriverProceed}
                                driverLatitude={driverLocation?.lat}
                                driverLongitude={driverLocation?.lng}
                                fullHeightRequired={true}
                                driverOnTheWayDestination={item?.details[0]?.otpByCustomer !== null ? true : false}
                            />
                        </div>
                    )}

                    <div className="text-overlay overflow-x-auto" style={{ padding: "10px 20px 20px 20px", zIndex: "1000" }}>


                        <div className="flex md:flex-row flex-col justify-between items-start mt-[1rem] overflow-auto mb-[6rem]">
                            <div className="flex sm:flex-col flex-row items-center justify-around w-full md:hidden">
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/front-left.jpg' style={{ boxShadow: '4px 5px 20px', borderRadius: '50%' }} className="h-[4rem] w-[4rem] object-contain" alt="" />

                                <div className='flex flex-col'>

                                    <div>
                                        <h6 className="m-0 font-[700] font-satoshi text-[16px] sm:text-[12px] text-[#0A0119] pb-[2px]">
                                            {item.details[0].reg}
                                        </h6>


                                        {/* <p className="font-[500] flex m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]"><p>Vehicle No</p> <span></span></p> */}
                                    </div>
                                    <div className='sm:hidden'>
                                        <p className="m-0 font-satoshi font-semibold text-[12px] sm:text-[12px] text-[#515151]">
                                            Requested On {new Date(item.details[0]?.systemDate)
                                                .toLocaleDateString('en-GB')
                                                .replace(/\//g, '/')}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Delivery Partner Info */}
                            <div className="bg-white rounded-xl w-[90vw] shadow p-4 space-y-3 mt-[2rem] mb-[2rem]">
                                <div className="flex items-center space-x-3">
                                    <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-red-600 font-bold text-xl">
                                        {item.details[0]?.chooseFromSelectedService == "crane" ? (
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumCrane.jpg' style={{ borderRadius: '50%' }} className="h-[3rem] w-[3rem] object-contain" alt="" />
                                        ) : (
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumRecoveryVan.jpg' style={{ borderRadius: '50%' }} className="h-[3rem] w-[4.5rem] object-contain" alt="" />
                                        )}
                                    </div>
                                    <div>
                                        <p className="font-semibold">{item.details[0].VendorDriverVehicleNo}</p>

                                         {/* <p className="text-green-600 text-[11px]">Experienced driver</p> */}

                                        {/* Driver name and contact number */}
                                        {/*
                                        <div className="flex gap-2 mt-2">
                                            <p className="text-sm text-zinc-500">Driver's Name: </p>
                                            <p className="text-sm font-semibold text-zinc-500">
                                                {item.details[0]?.driverName || "Not Available"}
                                            </p>
                                        </div> 
                                        <div className="flex gap-2 mt-1">
                                            <p className="text-sm text-zinc-500">Driver's Phone no: </p>
                                            <p className="text-sm font-semibold text-zinc-500">
                                                {item.details[0]?.driverNumber || "Not available"}
                                            </p>
                                        </div> */}
                                    </div>

                                </div>

                                <div className="text-[11px] text-blue-600 mt-2">
                                    <a href="#" className="flex items-center space-x-1">
                                        <Info size={14} />
                                        <span>View driver's current location on the map</span>
                                    </a>
                                </div>
                            </div>

                            {/* Delivery Details */}
                            <div className="bg-white rounded-xl  w-[90vw] shadow p-4 space-y-3">
                                <p className="text-xs text-orange-500 font-semibold">All your details in one place 👇</p>

                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-2 text-sm text-gray-700">
                                        <MapPin size={16} />
                                        <span>
                                            <h6
                                                className={`m-0 font-[700] font-satoshi text-[11px] sm:text-[24px] text-[#0A0119] pb-[6px] ${showFull
                                                    ? 'whitespace-normal overflow-visible text-clip'
                                                    : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px]'
                                                    }`}
                                                onClick={() => setShowFull(!showFull)}
                                            >
                                                {item.details[0]?.pickupLocation}
                                            </h6>
                                            <p className="font-[500] m-0 font-satoshi text-[11px] sm:text-[11px] text-[#515151]">
                                                Pickup Location
                                            </p>
                                        </span>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-2 text-sm text-gray-700">
                                        <MapPin size={16} />
                                        <span>
                                            <h6
                                                className={`font-[700] font-satoshi text-[11px] sm:text-[11px] mt-[1rem]  text-[#0A0119] pb-[6px] md:mt-0  ${showFull2
                                                    ? 'whitespace-normal overflow-visible text-clip'
                                                    : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px]'
                                                    }`}
                                                onClick={() => setShowFull2(!showFull2)}
                                            >
                                                {item.details[0]?.dropLocation}
                                            </h6>
                                            <p className="font-[500] mt-0 font-satoshi text-[11px] sm:text-[11px] text-[#515151]">
                                                Drop Location
                                            </p></span>
                                    </div>
                                </div>
                                <div className='flex justify-end'>
                                    <div className='gap-2 text-center'>
                                        <button className='mr-[1rem] mt-[-3rem] text-center h-[0.1rem] w-[0.1rem]' onClick={() => (window.location.href = 'tel: +91 7800 78 4700')}><PhoneCall alt="phone" /></button>
                                    </div>
                                </div>
                            </div>



                        </div>

                        {/* <p style={{ fontSize: '11px', gap: "10px" }}>205 D/15, Indl Estate, L B S Marg, Opp I O L, Near Amrutnagar, Near Ayodhya Chowk, Rohini, K Marg, Lower Parel Mumbai Maharashtra 4000067</p> */}
                        {Boolean(
                            !item.details[0]?.vendorMoved &&
                            item.details[0].customerAcceptedVendor &&
                            !item.details[0].closeOrder
                        ) && (
                                <p
                                    // onClick={readyToGo}
                                    className="opacity-0.5 fixed bottom-2 right-4 w-[200px]  px-4 py-3 text-[11px] mt-1 bg-green-600 border border-blue-600 text-white px-4 py-2 rounded-full font-bold flex items-center justify-center cursor-pointer z-50"
                                >
                                    Ready To Go
                                </p>
                            )}


                        {/* {Boolean(item.details[0]?.vendorMoved) && (<p style={{
                            fontSize: '12px',
                            marginTop: "10px",
                            background: "white",
                            padding: "10px",
                            border: '2px solid #000000',
                            textAlign: 'center',
                            borderRadius: '30px',
                            fontWeight: "bold",
                            color: "blue",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: "center",
                            position: "fixed",
                            right: "1rem",
                            bottom: "0.5rem",
                            width: "200px",
                        }} onClick={goToMap}>
                            Go to map
                            <KeyboardDoubleArrowRightIcon style={{
                                position: "absolute",
                                left: '10px'
                            }} />
                        </p>)} */}

                        {item.details[0]?.vendorDecision === 'reject' && (
                            <div className="flex fixed bottom-3 items-center justify-end mt-4 w-[90%]">
                                <textarea
                                    className="font-satoshi Registrationdetails-elem-9 w-full"
                                    style={{ textAlign: 'left', margin: "10px 5px 10px 10px", background: "lightgray" }}
                                    value={item.details[0]?.rejectionReason}
                                    readOnly
                                />
                            </div>
                        )}

                        {item.details[0]?.acceptedByAdmin === 'reject' && (
                            <div className="flex fixed bottom-3 items-center justify-end mt-4 w-[90%]">
                                <textarea
                                    className="font-satoshi Registrationdetails-elem-9 w-full"
                                    style={{ textAlign: 'left', margin: "10px 5px 10px 10px", background: "lightgray" }}
                                    value={item.details[0]?.reasonforRejection}

                                    readOnly
                                />
                            </div>
                        )}

                        {Boolean(item.details[0]?.cancelOrder) && (
                            <div>
                                <textarea
                                    className="Registrationdetails-elem-9"
                                    style={{ textAlign: 'left', margin: "30px 5px 20px 10px", width: '95%', background: "lightgray" }}
                                    value={item.details[0]?.cancelOrderReason}
                                    readOnly
                                />
                            </div>
                        )}


                        {Boolean(item.details[0]?.vendorMoved && !item.details[0]?.approvedReaching) && (<p style={{
                            fontSize: '11px',
                            marginTop: "5px",
                            background: "#21A6E9",
                            padding: "10px",
                            border: '1px solid blue',
                            textAlign: 'center',
                            borderRadius: '30px',
                            fontWeight: "bold",
                            color: "white",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: "center",
                            cursor: "pointer",
                            position: "fixed",
                            right: "1rem",
                            bottom: "0.5rem",
                            width: "200px",
                            opacity: "0.6"
                        }} className="fixed bottom-2 right-4 w-[200px] text-[11px] mt-1 bg-green-600 border border-blue-600 text-white px-4 py-2 rounded-full font-bold flex items-center justify-center cursor-pointer z-50" >
                            Reached At Spot Location
                        </p>)}

                        {Boolean(item.details[0]?.approvedReaching && item.details[0].detailsFilledAt === null) && (
                            <div style={{
                                fontSize: '11px',
                                marginTop: "5px",
                                background: "#21A6E9",
                                padding: "10px",
                                border: '1px solid blue',
                                textAlign: 'center',
                                borderRadius: '30px',
                                fontWeight: "bold",
                                color: "black",
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: "center",
                                position: "fixed",
                                right: "1rem",
                                bottom: "0.5rem",
                                width: "200px",
                                opacity: "0.6"
                            }} className="fixed bottom-2 right-4 w-[200px] text-[11px] mt-1 bg-green-600 border border-blue-600 text-white rounded-full font-bold flex items-center justify-center cursor-pointer z-50">
                                {/* <ModalButton state={{ accidentVehicleCode: item.AccidentVehicleCode, vendorType: item.details[0].vendorType, title: 'Vehicle Inspection' }} /> */}
                                {/* <ShowVehicleInspectionFlow accidentVehicleCode={item.AccidentVehicleCode} vendorType={item.details[0].vendorType}
                                > </ShowVehicleInspectionFlow> */}
                                <p>Driver is filling</p>
                            </div>
                        )}

                        {Boolean(item.details[0]?.vendorMoved && item.details[0]?.otpByCustomer == null && item.details[0].detailsFilledAt != null && item.details[0]?.approvedReaching) && (

                            <div className="fixed right-4 w-[200px] text-[11px] mt-1 border border-blue-600 bg-white px-6 rounded-full font-bold flex items-center justify-center bottom-[3rem] cursor-pointer z-50">

                                <button
                                    style={{
                                        fontSize: '11px',
                                        marginTop: "5px",
                                        background: "#21A6E9",
                                        padding: "10px",
                                        border: '1px solid blue',
                                        textAlign: 'center',
                                        borderRadius: '30px',
                                        fontWeight: "bold",
                                        color: "white",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: "center",
                                        position: "fixed",
                                        right: "1rem",
                                        bottom: "0.5rem",
                                        width: "200px",
                                        cursor: "pointer",
                                        opacity: "0.6"

                                    }}
                                >
                                    Please Input OTP
                                </button>

                                {isModalOpenForOTP && (
                                    <div
                                        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        onClick={() => inputRef.current?.focus()}
                                    >
                                        <div
                                            className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative"
                                            initial={{ scale: 0.8, opacity: 0 }}
                                            animate={{ scale: 1, opacity: 1 }}
                                            exit={{ scale: 0.8, opacity: 0 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            {/* Cross Button */}
                                            <button
                                                onClick={() => setIsModalOpenForOTP(false)}
                                                className="absolute top-2 right-2 p-2 rounded-full hover:bg-red-100 text-gray-500 hover:text-red-600 transition-all"
                                            >
                                                <X className="w-5 h-5" />
                                            </button>

                                            <p className="font-satoshi font-semibold text-[16px] mb-4 text-center">
                                                Please take OTP from Customer.
                                            </p>

                                            <div className="mt-1 px-6">
                                                {/* OTP Input Boxes */}
                                                <div className="flex justify-center items-center gap-2 mb-4">
                                                    <p className="text-xs font-satoshi">OTP :</p>
                                                    <input
                                                        ref={inputRef}
                                                        type="tel"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        value={otp}
                                                        onChange={handleChange}
                                                        maxLength={4}
                                                        className="absolute opacity-0 h-0 w-0"
                                                        autoFocus
                                                    />
                                                    {[...Array(4)].map((_, i) => (
                                                        <div
                                                            key={i}
                                                            className="font-satoshi w-6 h-6 border border-gray-400 rounded-md flex items-center justify-center text-xs font-semibold"
                                                        >
                                                            {otp[i] || ""}
                                                        </div>
                                                    ))}
                                                </div>

                                                {alertMessage && (
                                                    <div
                                                        style={{ marginTop: "20px", fontSize: "12px", padding: "10px" }}
                                                        className={`alert alert-${alertType} text-center`}
                                                        role="alert"
                                                    >
                                                        {alertMessage}
                                                    </div>
                                                )}

                                                {/* Done Button */}
                                                <div className="flex gap-4">
                                                    <button
                                                        className="bg-[#21A6E9] flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px] disabled:opacity-50"
                                                        onClick={() => sendOTP(item)}
                                                        disabled={otp.length !== 4}
                                                    >
                                                        Done
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* <div className="flex justify-center items-center gap-2 mt-1 px-6 ">
                                    <p className='text-xs font-satoshi'>Give OTP:</p>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        value={item.details[0]?.otp}
                                        maxLength={4}
                                        className="absolute opacity-0 pointer-events-none"
                                        autoFocus
                                        readOnly
                                    />
                                    {[...Array(4)].map((_, i) => (
                                        <div
                                            key={i}
                                            style={{ border: '1px solid black' }}
                                            className="font-satoshi w-5 h-5 border-1 mt-1 mb-2 border-gray-300 rounded-md flex items-center justify-center text-xs font-semibold"
                                        >
                                            {item.details[0]?.otp[i] || ""}
                                        </div>
                                    ))}
                                </div> */}
                            </div>

                        )}

                        {Boolean(item.details[0]?.otpByCustomer !== null && item.details[0].detailsFilledAt !== null) && (
                            <p style={{
                                fontSize: '11px',
                                marginTop: "5px",
                                background: "#21A6E9",
                                padding: "10px",
                                border: '1px solid blue',
                                textAlign: 'center',
                                borderRadius: '30px',
                                fontWeight: "bold",
                                color: "white",
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: "center",
                                position: "fixed",
                                right: "1rem",
                                bottom: "0.5rem",
                                width: "200px",
                                cursor: "pointer",
                                opacity: "0.6"

                            }} >
                                Job Done
                            </p>
                        )}

                        {item.details[0]?.issue_occured !== null && (
                            <div style={{ marginTop: "5px", fontSize: "12px", padding: "10px" }} className={`alert alert-danger text-center fixed bottom-[1rem]`} role="alert">
                                {item.details[0]?.issue_occured}
                            </div>
                        )}

                        {alertMessage && (
                            <div style={{ marginTop: "5px", fontSize: "12px", padding: "10px" }} className={`alert alert-${alertType} text-center`} role="alert">
                                {alertMessage}
                            </div>
                        )}
                    </div>

                </div>

            )}

        </div>
    )
}

export default VendorMoving;